// `.env.json` is generated by the `npm run build` command
import env from './.env';

export const environment = {
  production: true,
  actasAUCTIFF: true,
  observationsExpediente: true,
  integrationCita: true,
  secondary: false,
  hideRefreshForms: true,
  colorNavBarHeader: '#34495e',
  colorNavBarBody: '#2c3e50',
  version: env.npm_package_version,
  serverUrl: 'http://190.71.21.20:8489/api',
  defaultLanguage: 'es-CO',
  showDebugHelpers: false,
  credentialsKey: 'credentials',
  securityKey: '@iae=8il2a_j#0rx@)ti9oi61egi+7)^',
  storage: {
    prefix: 'iw',
    separator: '-',
    caseSensitive: false
  },
  servers_integrations: {
    CITA: {
      SERVER: 'http://citalinux.corpouraba.gov.co:8282/cita/',
      PATH_INTERNAL: 'core/services/integracion_cinco/',
      PATH_DOWNLOAD: 'core/services/modulos/documentos/utils/',
      PATH_VIEW: 'www/integracion_cinco/',
      ACTAS_MINISTERIO: 'acta_unica_ministerio/',
      NAME_FILES: {
        INDEX: 'index.php',
        DOWNLOAD_DOC: 'abrir_docto.php',
        VIEW_STICKER: 'RadicacionCinco.php',
        VIEW_MASK: 'CaratulaExpediente.php'
      },
      INDICES: false
    }
  },
  whitelistedDomains: ['http://190.71.21.20:8489'],
  supportedLanguages: ['es-CO', 'en-US']
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts